let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("92gV4")).then(() => parcelRequire('hTI3Y'));